export default {"src":"/_next/static/media/mod.b3f27192.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};